// extracted by mini-css-extract-plugin
export default {"cta":"FG-z","disabled":"GG-z"};